export default __webpack_public_path__ + "static/devsecops-iis-3c5a0025e587b2f670853a8327a96745.png";